import { FunctionComponent } from 'react'
import { Typography } from '@mui/material'

interface Props {
  snippet: string
}
const CodeSnippet: FunctionComponent<Props> = ({ snippet }) => {
  return (
    <Typography
      variant="body2"
      sx={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', p: 2, borderRadius: 1, width: '100%' }}
    >
      {snippet}
    </Typography>
  )
}

export default CodeSnippet
